import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DBC_SCREENS } from 'app/app.constants';
import { AuthService } from 'app/global-services/auth.service';
import { Observable, Subscription } from 'rxjs';

@Component({
    selector: 'app-bottom-nav',
    templateUrl: './bottom-nav.component.html',
    styleUrl: './bottom-nav.component.scss',
    standalone: false
})
export class BottomNavComponent {
    @Input() disableShareCardOption: boolean = false;
    @Output() bottomNavButtonClicked = new EventEmitter<void>();
    DBC_SCREENS = DBC_SCREENS;

    isLoggedIn$: Observable<boolean>;
    currentRouteFragment:DBC_SCREENS = DBC_SCREENS.CARDS;
    private routeFragmentSubscription!: Subscription;
    protected readonly navigator = navigator;

    constructor(
        private readonly router: Router,
        private readonly authService: AuthService,
        private readonly activatedRoute: ActivatedRoute
    ) {
        this.isLoggedIn$ = this.authService.isLoggedIn$;
    }
    
    ngOnInit() {
      this.routeFragmentSubscription = this.activatedRoute.fragment.subscribe(fragment => {
        this.currentRouteFragment = fragment ? (fragment as DBC_SCREENS) : DBC_SCREENS.CARDS;
      });
    }

    handleNavigation(targetRouteFragment: DBC_SCREENS) {
      if (targetRouteFragment === this.currentRouteFragment) {
        // Trigger event if the current route fragment is clicked more than once.
        // event is optional
        this.bottomNavButtonClicked.emit();
      } else {
        this.router.navigate(['/cards'], {
          fragment: targetRouteFragment,
          skipLocationChange: false,
        });
      }
    }


    ngOnDestroy() {
      this.routeFragmentSubscription?.unsubscribe();
    }
}